import { Component, OnDestroy } from '@angular/core';
import { DateFormatConstants, isNullOrUndefined } from '@uzurv/core';
import { Subject } from 'rxjs';

@Component({
  template: ''
})
export class BaseComponent implements OnDestroy {
  readonly destroyed$ = new Subject<void>();
  readonly isNullOrUndefined = isNullOrUndefined;
  readonly dateFormatConstants = DateFormatConstants;

  constructor() {}

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
